var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadmoreArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8436 5.28631V12.3574C14.8436 12.6225 14.7331 12.8656 14.5563 13.0424C14.3575 13.2413 14.1144 13.3517 13.8492 13.3517C13.2968 13.3738 12.8328 12.9098 12.8549 12.3574L12.8328 7.69489L6.07107 14.4566C5.67332 14.8543 5.0546 14.8543 4.65685 14.4566C4.2812 14.0809 4.25911 13.4401 4.65685 13.0424L11.4186 6.28068H6.77817C6.22575 6.30277 5.76171 5.83873 5.78381 5.28631C5.76171 4.73388 6.22575 4.26984 6.77817 4.29194H13.8492C14.4017 4.26984 14.8657 4.73388 14.8436 5.28631Z",
    fill: "#B41B05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadmoreArrowIcon);
export default __webpack_public_path__ + "static/media/readmore-arrow-icon.346d5f1e59cb5aedfe216a5453a305dd.svg";
export { ForwardRef as ReactComponent };